export default {
  "fr": {
    "form": {
      "actions": {
        "cancel": "Annuler",
        "saveChanges": "Sauvegardez les modifications"
      },
      "back": "Etape précédente",
      "password": "Mot de passe",
      "steps": "Etape {count} sur {total}",
      "writeEmployeeNameReject": "Noter <i><b>{employeeName}</b></i> pour terminer la suppression."
    }
  }
}